import { useQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { relativeDate } from '~/helpers/dateHelper'
import { ScorecardMutators } from '~/mutators/scorecards'
import { useTRPC } from '~/services/trpc'
import {
  WizardContent,
  WizardHeading,
  WizardOptions,
  WizardTemplate,
  WizardTitle,
} from '~/templates/wizard'

import { Button, cn } from '@hap/components'

import { ScorecardSections } from './-components/sections'

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/scorecard/$scorecardId/edit',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const trpc = useTRPC()
  const { data: scorecard } = useQuery(
    trpc.scorecards.getById.queryOptions(params.scorecardId),
  )

  const { publish, isPending: isPublishPending } = ScorecardMutators.usePublish()

  return (
    <WizardTemplate
      title={scorecard?.name ? `Configure ${scorecard.name}` : 'Loading...'}
    >
      <WizardHeading>
        <WizardTitle
          breadcrumbs={[
            {
              icon: 'sidebar',
              children: 'Scorecards',
              to: '/$alias/scorecards',
              from: Route.fullPath,
            },
            {
              children: scorecard?.name || 'Loading...',
              to: '/$alias/scorecard/$scorecardId',
              from: Route.fullPath,
            },
            {
              children: 'Configure',
            },
          ]}
        />
        <WizardOptions>
          <Button
            variant="ghost"
            onClick={() => {
              publish({
                scorecardId: params.scorecardId,
                values: { publish: !scorecard?.publishedAt },
              })
            }}
            loading={isPublishPending}
          >
            <span
              className={cn('bg-earth-yellow size-4 rounded-full', {
                'bg-lime-green': !!scorecard?.publishedAt,
              })}
            ></span>
            <span>
              {scorecard?.publishedAt
                ? `Activated ${relativeDate(scorecard.publishedAt)}`
                : 'Activate Scorecard'}
            </span>
          </Button>
        </WizardOptions>
      </WizardHeading>
      <WizardContent>
        {/*<header className="flex hidden shrink-0 items-center justify-between border-b p-6">
        <hgroup className="flex items-center gap-2">
          <LinkButton
            to="/$alias/scorecard/$scorecardId"
            from={Route.fullPath}
            icon="x"
            size="icon-sm"
            variant="ghost"
          />
          <h1 className="font-medium">Configure {scorecard?.name}</h1>
        </hgroup>
        <div>

        </div>
      </header>*/}
        <div className="flex h-0 w-full shrink grow items-stretch">
          <div className="flex min-w-1/2 shrink grow flex-col rounded-xl">
            <ScorecardSections
              scorecardId={params.scorecardId}
              sections={scorecard?.sections || []}
            />
          </div>
          <div className="w-1/2 shrink grow overflow-hidden">
            <Outlet />
          </div>
        </div>
      </WizardContent>
    </WizardTemplate>
  )
}
